import styled from 'styled-components';

export const Text = styled.div`
    color: ${props => props.color};
    margin: 5px;
    font-size:  ${props => props.fontSize}; 
    text-align: center;
    font-weight: ${props => props.bold ? 'bold' : 'normal'};
    cursor: ${props => props.isClickable ? 'pointer' : 'default'};
`; 